<template>
    <div class="container loanMasterInputMoney" v-if="isVisible" style="z-index:1">
        <div class="bankAuditDialog">
            <el-row>
                <el-col :span="24">
                    <div class="bankAuditHeader">
                        <div class="bankAuditHeaderName"></div>
                        <div class="bankAuditHeaderClose" title="关闭" @click="onChangeClose">×</div>
                    </div>
                </el-col>
            </el-row>
            <el-tabs v-model="activeName">
                <el-tab-pane label="审核信息" name="first">
                    <el-scrollbar :height="scrollHeight" :noresize="true">
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    基本信息
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="3" v-if="flowInfo.PersonFlag===2">
                                    <div class="bankAuditLB">企业名称：</div>
                                </el-col>
                                <el-col :span="5" v-if="flowInfo.PersonFlag===2">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanApply.PersonCompanyText"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="3" v-if="flowInfo.PersonFlag===1">
                                    <div class="bankAuditLB">姓名：</div>
                                </el-col>
                                <el-col :span="5" v-if="flowInfo.PersonFlag===1">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="flowInfo.Name"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="3" v-if="flowInfo.PersonFlag===2">
                                    <div class="bankAuditLB">法定代表人：</div>
                                </el-col>
                                <el-col :span="5" v-if="flowInfo.PersonFlag===2">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="flowInfo.Name"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">联系方式：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanApply.Phone"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">区域：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <!-- <el-input
                                            v-model="bankInfoObj.AreaName"
                                            size="small"
                                            placeholder="请输入区域">
                                        </el-input> -->
                                        <el-select disabled v-model="loanAudit.Area" size="small" placeholder="">
                                            <el-option :label="area.AreaName" :value="area.AreaName" :key="area.AreaName" v-for="area in areaList"></el-option>
                                        </el-select>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">营业执照号/身份证号码：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanApply.PersonCompanyKey"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">主营业务：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.Business"
                                            size="small"
                                            style="width:250px;"
                                            :placeholder="secondBusinessPlaceHolder">
                                            123
                                        </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">二级分类：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.ThirdBusiness"
                                            size="small"
                                            style="width:250px;"
                                            :placeholder="secondBusinessPlaceHolder">
                                        </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="3" v-if="loanAudit.BusinessDetail">
                                    <div class="bankAuditLB">业务说明：</div>
                                </el-col>
                                <el-col :span="5" v-if="loanAudit.BusinessDetail">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.BusinessDetail"
                                            size="small"
                                            style="width:250px;"
                                            :placeholder="secondBusinessPlaceHolder">
                                        </el-input>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="3">
                                    <div class="bankAuditLB">客户类型：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-select disabled v-model="loanAudit.CustomType" placeholder="" size="small">
                                            <el-option
                                            v-for="item in khlx"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">客户性质：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-select disabled v-model="loanAudit.CustomProperty" placeholder="" size="small">
                                            <el-option
                                            v-for="item in khxz"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">项目类别：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-select disabled v-model="loanAudit.ProTypeName" placeholder="" size="small" @change="proTypeChange">
                                            <el-option
                                            v-for="item in proTypeList"
                                            :key="item.ProTypeName"
                                            :label="item.ProTypeName"
                                            :value="item.ProTypeName">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="3">
                                    <div class="bankAuditLB">项目风险比例(%)：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.RiskSharing"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">贷款金额(万元)：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanApply.Money"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                <!-- <el-col :span="3">
                                    <div class="bankAuditLB">贷款合同号：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            v-model="loanAudit.LoanCode"
                                            size="small"
                                            placeholder="请输入贷款合同号">
                                        </el-input>
                                    </div>
                                </el-col> -->
                                 <el-col :span="3">
                                    <div class="bankAuditLB">贷款银行：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="bankInfoObj.BankSiteName"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                                <!-- <el-col :span="3">
                                    <div class="bankAuditLB">还款状态：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-select v-model="loanAudit.ReturnMoneyStatus" placeholder="请选择" size="small">
                                            <el-option
                                            v-for="item in hkzt"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </el-col> -->
                                <el-col :span="3">
                                    <div class="bankAuditLB">担保期限(月)：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.LoanMonth"
                                            size="small"
                                            onkeyup="value=value.replace(/[^0-9]/g,'')"
                                            placeholder=""
                                            @change="onDbqxChange">
                                        </el-input>
                                    </div>
                                </el-col>
                                <!-- <el-col :span="3">
                                    <div class="bankAuditLB">出具担保函时间：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-date-picker
                                            v-model="loanAudit.GuaranteeLetterTime"
                                            size="small"
                                            type="date"
                                            placeholder="选择出具担保函时间">
                                        </el-date-picker>
                                    </div>
                                </el-col> -->
                                <el-col :span="3">
                                    <div class="bankAuditLB">到期时间：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-date-picker
                                            disabled
                                            v-model="loanAudit.LoanEndTime"
                                            size="small"
                                            type="date"
                                            placeholder="">
                                        </el-date-picker>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">贷款合同号：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.LoanCode"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                               
                        </el-row>
                        <el-row>
                                <el-col :span="3">
                                    <div class="bankAuditLB">担保费率(%)：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.GuaranteeRate"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">担保费(元)：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.LoanMoney"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">借款利率：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.LoanRate"
                                            oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                
                        </el-row>
                        <el-row>
                                <el-col :span="3">
                                    <div class="bankAuditLB">五级分类：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-select disabled v-model="loanAudit.Category" placeholder="请选择" size="small">
                                            <el-option
                                            v-for="item in wfl"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">主调：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.FristInquirer"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">副调：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.SecondInquirer"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                <!-- <el-col :span="3">
                                    <div class="bankAuditLB">委托担保合同号：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            v-model="loanAudit.EntrustedGuarantee"
                                            size="small"
                                            placeholder="请输入委托担保合同号">
                                        </el-input>
                                    </div>
                                </el-col> -->
                                
                <el-col :span="3">
                                    <div class="bankAuditLB">银行客户经理：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.AccountManager"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">银行客户经理联系方式：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.AccountManagerPhone"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    经营情况
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="3">
                                    <div class="bankAuditLB">资产总额（万元）：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.TotalAssets"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">资产负债率（%）：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.AssetCoverage"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">上年营业收入（万元）：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.LastYearIncomeAudit"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">上年利润（万元）：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.LastYearProfitAudit"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">上年税收（万元）：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.LastYearTaxAudit"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">从业人数：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.PeopleCountAudit"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle" style="position: relative;">
                                    <div class="bankAuditSplit"></div>
                                    反担保方式
                                    <div style="left: 0px;top: 0px;position: absolute;width: 100%;display: flex;justify-content: center;align-items: center;height: 40px">
                                      <el-radio-group disabled v-model="loanAudit.GuaranteeType" style="margin:0px auto;" @change="loanTypeChange">
                                          <el-radio :label="1">信用</el-radio>
                                          <el-radio :label="2">保证</el-radio>
                                          <el-radio :label="3">组合</el-radio>
                                          <el-radio :label="4">抵押</el-radio>
                                      </el-radio-group>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                        <template v-if="loanAudit.GuaranteeType===1">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bankAuditLB">暂无信息</div>
                                </el-col>
                            </el-row>
                        </template>
                        <template v-if="loanAudit.GuaranteeType===2">
                            <template v-if="loanMortgage&&loanMortgage.length>0">
                                <template v-for="(item,index) in loanMortgage" :key="item.Id">
                                    <template v-if="item.Type === -1" >
                                        <el-row>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">保证人姓名：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.Guarantor"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">身份证号码：</div>
                                            </el-col>
                                            <el-col :span="5">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.GuarantorID"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </template>
                                </template>
                            </template>
                        </template>
                        <template v-if="loanAudit.GuaranteeType===3">
                            <template v-if="loanMortgage&&loanMortgage.length>0">
                                <template  v-for="(item,index) in loanMortgage" :key="item.Id">
                                    <template v-if="item.Type === -1" >
                                        <el-row>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">保证人姓名：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.Guarantor"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">身份证号码：</div>
                                            </el-col>
                                            <el-col :span="5">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.GuarantorID"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </template>
                                    <template v-if="item.Type === 0" >
                                        <el-row>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">不动产：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.BdcName"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">权证号：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.BdcQzh"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">面积：</div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.BdcArea"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">价值(万元)：</div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.BdcMoney"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">抵押权证号：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.BdcDyqzh"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                    </el-row>
                                    </template>
                                    <template v-else-if="item.Type === 1">
                                        <el-row>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">设备：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.SbName"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">数量：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.SbCount"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">型号：</div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.SbType"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">价值(万元)：</div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.SbMoney"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">抵押权证号：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.SbDyqzh"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                    </el-row>
                                    </template>
                                    <template v-else-if="item.Type === 2">
                                        <el-row>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">水域滩涂：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.SytName"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">权证号：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.SytQzh"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">面积：</div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.SytArea"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">价值(万元)：</div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.SytMoney"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">抵押权证号：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.SytDyqzh"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                    </el-row>
                                    </template>
                                    <template v-else-if="item.Type === 3">
                                        <el-row>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">农村承包土地：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.NccbtdName"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">权证号：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.NccbtdQzh"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">面积：</div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.NccbtdArea"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">价值(万元)：</div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.NccbtdMoney"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">抵押权证号：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.NccbtdDyqzh"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                    </el-row>
                                    </template>
                                    <template v-else-if="item.Type === 4">
                                        <el-row>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">股权：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.GqName"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">数量：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.GqCount"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">价值(万元)：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.GqMoney"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">抵押权证号：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.GqDyzqh"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                    </el-row>
                                    </template>
                                    <template v-else-if="item.Type === 5">
                                        <el-row>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">其他：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.OtherBfwName"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">规格：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.OtherBfwGg"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">价值(万元)：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.OtherBfwMoney"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">抵押权证号：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.OtherBfwDyqzh"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                    </el-row>
                                    </template>
                                </template>
                            </template>
                        </template>
                        <template v-if="loanAudit.GuaranteeType===4">
                            <template v-if="loanMortgage&&loanMortgage.length>0">
                                <template  v-for="(item,index) in loanMortgage" :key="item.Id">
                                    <template v-if="item.Type === 0" >
                                        <el-row>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">不动产：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.BdcName"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">权证号：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.BdcQzh"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">面积：</div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.BdcArea"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">价值(万元)：</div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.BdcMoney"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">抵押权证号：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.BdcDyqzh"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                    </el-row>
                                    </template>
                                    <template v-else-if="item.Type === 1">
                                        <el-row>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">设备：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.SbName"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">数量：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.SbCount"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">型号：</div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.SbType"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">价值(万元)：</div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.SbMoney"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">抵押权证号：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.SbDyqzh"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                    </el-row>
                                    </template>
                                    <template v-else-if="item.Type === 2">
                                        <el-row>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">水域滩涂：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.SytName"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">权证号：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.SytQzh"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">面积：</div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.SytArea"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">价值(万元)：</div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.SytMoney"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">抵押权证号：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.SytDyqzh"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                    </el-row>
                                    </template>
                                    <template v-else-if="item.Type === 3">
                                        <el-row>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">农村承包土地：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.NccbtdName"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">权证号：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.NccbtdQzh"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">面积：</div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.NccbtdArea"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">价值(万元)：</div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.NccbtdMoney"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">抵押权证号：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.NccbtdDyqzh"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                    </el-row>
                                    </template>
                                    <template v-else-if="item.Type === 4">
                                        <el-row>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">股权：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.GqName"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">数量：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.GqCount"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">价值(万元)：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.GqMoney"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">抵押权证号：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.GqDyzqh"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                    </el-row>
                                    </template>
                                    <template v-else-if="item.Type === 5">
                                        <el-row>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">其他：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.OtherBfwName"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">规格：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.OtherBfwGg"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">价值(万元)：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.OtherBfwMoney"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <div class="bankAuditLB">抵押权证号：</div>
                                            </el-col>
                                            <el-col :span="3">
                                                <div class="bankAuditContent"> 
                                                    <el-input
                                                        disabled
                                                        v-model="item.OtherBfwDyqzh"
                                                        size="small"
                                                        placeholder="">
                                                    </el-input>
                                                </div>
                                            </el-col>
                                    </el-row>
                                    </template>
                                </template>
                            </template>
                        </template>
                        <template v-if="!loanMortgage||loanMortgage.length===0">
                            <div style="line-height: 60px!important;text-align: center;">暂无信息</div>
                        </template>
                        <el-row>
                                <el-col :span="24">
                                    <div class="bankAuditTitle">
                                        <div class="bankAuditSplit"></div>
                                        信用评分
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="3">
                                        <div class="bankAuditLB">征信记录：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select disabled v-model="loanAudit.xyzk_value1" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in xyzk_list1"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">征信查询:</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select  disabled v-model="loanAudit.xyzk_value2" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in xyzk_list2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">诉讼及执行情况：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent">  
                                            <el-select  disabled v-model="loanAudit.xyzk_value3" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in xyzk_list3"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">借款人稳定性：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select  disabled v-model="loanAudit.xyzk_value4" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in xyzk_list4"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">企业经营情况：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select  disabled v-model="loanAudit.xyzk_value5" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in xyzk_list5"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="3">
                                        <div class="bankAuditLB">财务状况：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select  disabled v-model="loanAudit.hknl_value1" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in hknl_list1"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">收入及现金流:</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select disabled v-model="loanAudit.hknl_value2" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in hknl_list2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">抵押物价值：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select disabled v-model="loanAudit.hknl_value3" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in hknl_list3"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="3">
                                        <div class="bankAuditLB">担保人信用及能力：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select disabled v-model="loanAudit.dbcs_value1" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in dbcs_list1"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">担保方式及风险:</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select disabled v-model="loanAudit.dbcs_value2" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in dbcs_list2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="7"></el-col>
                                <el-col :span="10">
                                <div class="bankAuditInfoTable">
                                    <table class="bg-table" border="1" bordercolor="#4e717d">
                        <tr style="font-weight: bold;">
                        <td colspan="2">信用状况</td>
                        <td colspan="2">还款能力</td>
                        <td colspan="2">担保措施</td>
                        <td colspan="2">额外分：</td>
                        <td colspan="2">最终得分</td>
                        <td colspan="2">预授信(万元）</td>
                        </tr>
                        <tr style="font-weight: bold;">
                        <td colspan="2">{{ scorelist[0] }}</td>
                        <td colspan="2">{{ scorelist[1] }}</td>
                        <td colspan="2">{{ scorelist[2] }}</td>
                        <td colspan="2">{{ scorelist[3] }}</td>
                        <td colspan="2">{{ scorelist[4] }}</td>
                        <td colspan="2">{{ scorelist[5] }}</td>
                        </tr>
                      </table> 
                                </div>
                            </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <div class="bankAuditTitle">
                                        <div class="bankAuditSplit"></div>
                                        资产评价
                                    </div>
                                </el-col>
                            </el-row>
                             <el-row>
                                     <el-col :span="3">
                                        <div class="bankAuditLB">土地流转信息（亩）：</div>
                                    </el-col>
                                    <el-col :span="9">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                            disabled
                                                v-model="loanCreditArea.area"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    信用报告
                                </div>
                            </el-col>
                        </el-row>
                        
                        <template v-if="zxbglist.length>0">
                                    <template v-for="(item,index) in zxbglist" :key="item.Id">
                                            <el-row>
                                                <el-col :span="2">
                                                    <div class="bankAuditLB">贷款银行：</div>
                                                </el-col>
                                                <el-col :span="3">
                                                    <div class="bankAuditContent"> 
                                                        <el-input disabled
                                                            v-model="item.name"
                                                            size="small"
                                                            placeholder="请输入贷款银行">
                                                        </el-input>
                                                    </div>
                                                </el-col>
                                                <el-col :span="2">
                                                    <div class="bankAuditLB">贷款余额（万元）：</div>
                                                </el-col>
                                                <el-col :span="2">
                                                    <div class="bankAuditContent"> 
                                                        <el-input disabled
                                                            v-model="item.money"
                                                            size="small"
                                                            placeholder="请输入贷款金额">
                                                        </el-input>
                                                    </div>
                                                </el-col>
                                                <el-col :span="2">
                                                    <div class="bankAuditLB">担保方式：</div>
                                                </el-col>
                                                <el-col :span="2">
                                                    <div class="bankAuditContent"> 
                                                        <el-select disabled v-model="item.bzfs" size="small" placeholder="请选择">
                                                          <el-option label="信用" value="1"></el-option>
                                                          <el-option label="保证" value="2"></el-option>
                                                          <el-option label="抵押" value="3"></el-option>
                                                          <el-option label="组合" value="4"></el-option>
                                                      </el-select>
                                                    </div>
                                                </el-col>
                                                <el-col :span="2">
                                                    <div class="bankAuditLB">是否逾期：</div>
                                                </el-col>
                                                <el-col :span="1">
                                                    <div class="bankAuditContent">
                                                        <el-select disabled v-model="item.islate" size="small" placeholder="请选择">
                                                          <el-option label="是" value="1"></el-option>
                                                          <el-option label="否" value="0"></el-option>
                                                      </el-select>
                                                    </div>
                                                </el-col>
                                                <el-col :span="2" v-if="item.islate=='1'">
                                                    <div class="bankAuditLB">逾期期限：</div>
                                                </el-col>
                                                <el-col :span="2" v-if="item.islate=='1'">
                                                    <div class="bankAuditContent"> 
                                                        <el-input disabled
                                                            v-model="item.month"
                                                            size="small"
                                                            placeholder="请输入贷款金额">
                                                        </el-input>
                                                    </div>
                                                </el-col>
                                                <el-col :span="1" v-if="item.islate=='1'">
                                                    <div class="bankAuditLB">金额：</div>
                                                </el-col>
                                                <el-col :span="2" v-if="item.islate=='1'">
                                                    <div class="bankAuditContent"> 
                                                        <el-input
                                                            disabled
                                                            v-model="item.lateMoney"
                                                            size="small"
                                                            placeholder="请输入逾期金额">
                                                        </el-input>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                    </template>
                                </template>
                         <template v-else>
                            <el-row>
                                <el-col :span="2">
                                    <div class="bankAuditLB">暂无信息</div>
                                </el-col>
                            </el-row>
                        </template>
                        <el-row>
                                <el-col :span="24">
                                    <div class="bankAuditTitle">
                                        <div class="bankAuditSplit"></div>
                                        政务信息
                                    </div>
                                </el-col>
                            </el-row>
                             <el-row>
                                     <el-col :span="2">
                                        <div class="bankAuditLB">婚姻信息：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                disabled
                                                v-model="loanCreditArea.HYXX"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="bankAuditLB">户籍信息：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                            disabled
                                                v-model="loanCreditArea.HJXX"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="bankAuditLB">社保信息：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                            disabled
                                                v-model="loanCreditArea.SBXX"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="bankAuditLB">公积金信息：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                            disabled 
                                                v-model="loanCreditArea.GJJXX"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    村镇干部评价
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                                 <el-col :span="2">
                                        <div class="bankAuditLB" >积分制积分：</div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                               disabled
                                                v-model="loanCredit.comment2_jfzjf"
                                                size="small"
                                                placeholder="请输入积分制积分">
                                            </el-input>
                                        </div>
                                    </el-col>
                                <el-col :span="2">
                                    <div class="bankAuditLB" >规模：</div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanCredit.comment2_gm"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                 <el-col :span="2">
                                    <div class="bankAuditLB">技术：</div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanCredit.comment2_js"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                         <el-col :span="2">
                                    <div class="bankAuditLB" >效益：</div>
                                </el-col>
                                <el-col :span="10">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanCredit.comment2_xy"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                 <el-col :span="2">
                                    <div class="bankAuditLB">综合信誉：</div>
                                </el-col>
                                <el-col :span="10">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanCredit.comment2"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    同行评价
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="2">
                                    <div class="bankAuditLB" >规模：</div>
                                </el-col>
                                <el-col :span="10">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanCredit.comment_gm"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                 <el-col :span="2">
                                    <div class="bankAuditLB">技术：</div>
                                </el-col>
                                <el-col :span="10">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanCredit.comment_js"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="2">
                                    <div class="bankAuditLB" >效益：</div>
                                </el-col>
                                <el-col :span="10">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanCredit.comment_xy"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                 <el-col :span="2">
                                    <div class="bankAuditLB">综合信誉：</div>
                                </el-col>
                                <el-col :span="10">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanCredit.comment"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    合同号信息
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="2">
                                    <div class="bankAuditLB">委托担保合同号：</div>
                                </el-col>
                                <el-col :span="10">
                                    <div class="bankAuditContent"> 
                                            <el-input
                                                disabled
                                                v-model="loanAudit.WTDBHTH"
                                                size="small"
                                                placeholder="请输入合同号">
                                            </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="2">
                                    <div class="bankAuditLB" >银行担保合同号：</div>
                                </el-col>
                                <el-col :span="10">
                                    <div class="bankAuditContent"> 
                                            <el-input 
                                                disabled
                                                v-model="loanAudit.YHDBHTH"
                                                size="small"
                                                placeholder="请输入合同号">
                                            </el-input>
                                    </div>
                                </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    附件信息
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditFileList" v-if="fileList_FJ.length>0">
                                    <div v-for="(item,index) in fileList_FJ" :key="index">
                                        <div class="bankAuditFileLink" :title="item.name">
                                            <a :href="item.url" :download="item.name">{{item.name}}</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="bankAuditFileList" v-else>
                                    <div style="padding-left:30px;">无</div>
                                </div>
                            </el-col>
                        </el-row>
                    <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    确认信息
                                </div>
                            </el-col>
                        </el-row>
                        <el-form :rules="rules2" ref="ruleForm2" :model="loanAudit">
                            <el-form :rules="rules" ref="ruleForm" style="width:100%" :model="flowInfo">
                                <el-row>
                                    <!-- <el-col :span="3">
                                        <div class="bankAuditLB">担保费(万元)：</div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="bankAuditContent"> 
                                            <el-form-item  prop="GuaranteeFee" >
                                                <el-input
                                                    v-model.number="flowInfo.GuaranteeFee"
                                                    size="small"
                                                    placeholder="请输入担保费(万元)">
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col> -->
                                    <el-col :span="3">
                                        <div class="bankAuditLB">最终贷款金额(万元)：</div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="FinalMoney">
                                                <el-input
                                                    v-model.number="flowInfo.FinalMoney"
                                                    size="small"
                                                    placeholder="请输入最终贷款金额(万元)">
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">担保函年份：</div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditContent"> 
                                            <el-form-item  prop="LoanYear" >
                                                <el-input
                                                    v-model.number="flowInfo.LoanYear"
                                                    size="small"
                                                    placeholder="请输入担保函年份">
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">担保函序号：</div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="LoanTime">
                                                <el-input
                                                    v-model="flowInfo.LoanTime"
                                                    size="small"
                                                    placeholder="请输入担保函序号">
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">委托担保合同号：</div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditContent">
                                                <el-form-item prop="EntrustedGuarantee">
                                                    <el-input
                                                        v-model="loanAudit.EntrustedGuarantee"
                                                        size="small"
                                                        placeholder="请输入委托担保合同号">
                                                    </el-input>
                                                </el-form-item> 
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </el-form>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditOperate">
                                    <el-button size="small" type="danger" @click="onReturnFlow">拒绝</el-button>
                                    <el-button size="small" type="success" @click="onPassFlow">通过</el-button>
                                    <!-- <el-button size="small" type="warning" @click="onRollBacklow">退回</el-button> -->
                                </div>
                            </el-col>
                        </el-row>
                    </el-scrollbar>
                </el-tab-pane>
                <el-tab-pane label="信用信息" name="second">
                    <el-scrollbar :height="scrollHeight" :noresize="true">
                        <el-tabs v-model="activeNameZx" type="card" @tab-click="handleClick">
                               <template v-if="flowInfo.PersonFlag===2">
                                <el-row>
                                    <el-col :span="24">
                                        <div class="bankAuditSecondLB">
                                            <div class="bankAuditSecondSplit"></div>
                                            营业执照信息
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <div class="bankAuditInfoTitle">
                                            <img width="50" height="50" :src="detailResult.ImageUrl"/>
                                            <div class="bankAuditInfoName">{{detailResult.Name}}</div>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row v-if="activeNameZx==='first'">
                                    <el-col :span="24">
                                        <div class="bankAuditInfoTable">
                                            <table border="1" bordercolor="#4e717d">
                                                <tr>
                                                    <td class="title">登记机关</td>
                                                    <td>{{detailResult.BelongOrg}}</td>
                                                    <td class="title">法定代表人名</td>
                                                    <td style="color:bule ">{{detailResult.OperName}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="title">成立日期</td>
                                                    <td>{{detailResult.StartDate}}</td>
                                                    <td class="title">企业状态</td>
                                                    <td>{{detailResult.Status}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="title">注册资本</td>
                                                    <td>{{detailResult.RegistCapi}}</td>
                                                    <td class="title">实缴资本</td>
                                                    <td>{{detailResult.RecCap}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="title">企业类型</td>
                                                    <td>{{detailResult.EconKind}}</td>
                                                    <td class="title">注册号</td>
                                                    <td>{{detailResult.No}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="title">地址</td>
                                                    <td colspan="3">{{detailResult.Address}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="title">经营范围</td>
                                                    <td colspan="3">{{detailResult.Scope}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <div class="bankAuditSecondLB">
                                            <div class="bankAuditSecondSplit"></div>
                                            诉讼信息
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <div class="bankAuditInfoTable">
                                            <table class="bg-table" border="1" bordercolor="#4e717d">
                                        <tr>
                                            <!-- <td class="title">失信被执行数量</td>
                                            <td>{{caseResult[0]}}</td>
                                            <td class="title">被执行数量</td>
                                            <td>{{caseResult[1]}}</td>
                                            <td class="title">严重违法数量</td>
                                            <td>{{caseResult[2]}}</td>
                                            <td class="title">裁判文书数量</td>
                                            <td>{{caseResult[3]}}</td> -->
                                            <td class="title" >失信被执行数量</td>
                        <td v-if="caseResult[0]>0" 
                          style="cursor: pointer;color: red" @click="queryClick(0)">
                          {{caseResult[0]}}</td>
                        <td v-else>0</td>
                        <td class="title">被执行数量</td>
                        <td v-if="caseResult[1]>0" 
                          style="cursor: pointer;color: red" @click="queryClick(1)">
                          {{caseResult[1]}}</td>
                        <td v-else>0</td>
                        <td class="title">严重违法数量</td>
                        <td v-if="caseResult[2]>0" 
                          style="cursor: pointer;color: red" @click="queryClick(2)">
                          {{caseResult[2]}}</td>
                        <td v-else>0</td>
                        <td class="title">裁判文书数量</td>
                        <td v-if="caseResult[3]>0" 
                          style="cursor: pointer;color: red" @click="queryClick(3)">
                          {{caseResult[3]}}</td>
                        <td v-else>0</td>
                                        </tr>
                                    </table>
                                        </div>
                                    </el-col>
                                </el-row>


                                <el-row v-if="dataShow">
                                    <el-col :span="24">
                                        <div class="bankAuditSecondLB">
                                            <div class="bankAuditSecondSplit"></div>
                                            {{labelList[sxtype]}}信息
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row v-if="dataShow">
                                    <el-col :span="24">
                                        <div class="bankAuditInfoTable">
                                            <table v-if="sxtype==3" class="bg-table" border="1" bordercolor="#4e717d">
                    <tr style="font-weight: bold;">
                        <td style="width:20%">案号</td>
                        <td style="width:20%">案由</td>
                        <td style="width:15%">发布日期</td>
                        <td style="width:15%">金额（元）</td>
                        <td style="width:15%">角色</td>
                        <td style="width:15%">案件声明</td>
                    </tr>
                    <tr v-for="(abc,i) in sxdataList">
                            <td>{{abc.CaseNo}}</td>
                            <td>{{abc.CaseReason}}</td>
                            <td>{{abc.PublishDate}}</td>
                            <td>{{abc.Amount}}</td>
                            <td>{{abc.RoleType}}</td>
                              <td>{{abc.Statement}}</td>
                        </tr>
                   </table> 
                   <table v-if="sxtype==2" class="bg-table" border="1" bordercolor="#4e717d">
                    <tr style="font-weight: bold;">
                        <td style="width:40%">列入原因</td>
                        <td style="width:30%">列入决定机关</td>
                        <td style="width:15%">列入时间</td>
                        <td style="width:15%">移除时间</td>
                    </tr>
                    <tr v-for="(abc,i) in sxdataList">
                            <td>{{abc.AddReason}}</td>
                            <td>{{abc.AddOffice}}</td>
                            <td>{{abc.AddDate}}</td>
                            <td>{{abc.RemoveDate}}</td>
                        </tr>
                   </table> 
                   <table v-if="sxtype==1" class="bg-table" border="1" bordercolor="#4e717d">
                    <tr style="font-weight: bold;">
                        <td style="width:20%">案号</td>
                        <td style="width:20%">立案时间</td>
                        <td style="width:20%">执行法院</td>
                        <td style="width:20%">执行标的（元）</td>
                        <td style="width:20%">疑似申请执行人</td>
                    </tr>
                    <tr v-for="(abc,i) in sxdataList">
                            <td>{{abc.Anno}}</td>
                            <td>{{abc.Liandate}}</td>
                            <td>{{abc.JudgeDate}}</td>
                            <td>{{abc.Biaodi}}</td>
                            <td>{{abc.SuspectedApplicant}}</td>
                        </tr>
                   </table> 
                   <table v-if="sxtype==0" class="bg-table" border="1" bordercolor="#4e717d">
                    <tr style="font-weight: bold;">
                        <td style="width:20%">案号</td>
                        <td style="width:15%">履行情况</td>
                        <td style="width:15%">发布日期</td>
                        <td style="width:15%">金额（元）</td>
                        <td style="width:35%">失信行为</td>
                    </tr>
                    <tr v-for="(abc,i) in sxdataList">
                            <td>{{abc.Anno}}</td>
                            <td>{{abc.Executestatus}}</td>
                            <td>{{abc.Publicdate}}</td>
                            <td>{{abc.Amount}}</td>
                            <td>{{abc.ActionRemark}}</td>
                        </tr>
                   </table> 
                   <div v-if="mlShow" style=" margin: 10px 40% 4px 40%;width: 20%;">
                     <div @click="getList(-1)"
                     style="cursor: pointer;width:40%;float: left;" >上一页</div>
                     <div style="width:20%;float: left;">{{ pageIndex }}</div> 
                     <div  @click="getList(1)"
                     style="cursor: pointer;width:40%;float: left;">下一页</div>
                   </div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </template>
                                <el-row>
                                    <el-col :span="24">
                                        <div class="bankAuditSecondLB">
                                            <div class="bankAuditSecondSplit"></div>
                                            农业信息
                                        </div>
                                    </el-col>
                                </el-row>
                        <el-row v-if="llTableData.length==0">
                                <el-col :span="2">
                                    <div class="bankAuditLB">暂无信息</div>
                                </el-col>
                            </el-row>
                        <el-row v-else>
                            <el-col :span="24">
                                <div class="bankAuditInfoTable">
                                    <table class="bg-table" border="1" bordercolor="#4e717d">
                        <tr style="font-weight: bold;">
                        <td colspan="4">权证流水号</td>
                        <td colspan="4">发包方名称</td>
                        <td colspan="4">承包方期限</td>
                        <td colspan="2">承包方名称</td>
                        <td colspan="2">地块面积</td>
                        <td colspan="2">地块总数</td>
                        <td colspan="3">土地类型</td>
                        <td colspan="3">土地用途</td>
                        </tr>
                    <tr v-for="(abc,i) in llTableData">
                            <td colspan="4">{{abc.QZLSH}}</td>
                            <td colspan="4">{{abc.FBFMC}}</td>
                            <td colspan="4">{{abc.CBQXQ}}至{{abc.CBQXZ}}</td>
                            <td colspan="2">{{abc.name}}</td>
                            <td colspan="2">{{abc.area}}</td>
                            <td colspan="2">{{abc.num}}</td>
                            <td colspan="3">{{abc.TDLYLX}}</td>
                            <td colspan="3">{{abc.TDYT}}</td>
                        </tr>
                      </table> 
                                </div>
                            </el-col>
                        </el-row>
                          
                        <el-row>
                                    <div style="height:20px"></div>
                                </el-row>
                        </el-tabs>
                    </el-scrollbar>
                </el-tab-pane>
            </el-tabs>
            
        </div>
    </div>
</template>

<script>
import indexJs from "./index.js";
  export default indexJs;
</script>

<style>
    @import url(./assets/style/style.less);
</style>
